import { axios } from '@Root/API'

export const getAdmissionBapStatuses = () => {
	return axios.get(`data-admission-bap-statuses`)
}
